<template>
  <div v-if="isLoading" class="loading-overlay">
    <div class="loading-spinner"></div>
  </div>
  <div class="container-fluid py-4">
    <div class="d-sm-flex justify-content-between">
      <div>
      </div>
    </div>
    <div class="row">
      <div class="col-12">
        <div class="card mt-4">
          <div class="card-header">
            <h5 class="mb-0">Listado de Áreas</h5>
          </div>
          <div class="table-responsive">
            <div v-if="error !== ''">
              <label
                  type="error"
                 :value="alert"
                  class="alert-warning text-bold"
              >
                {{ error }}
              </label>
            </div>
            <div v-if="message !== ''" class="bg-gradient-light">
              <label
                  type="success"
                  :value="show_text"
              >
                {{ message }}
              </label>
            </div>
            <div class="table-responsive">
              <table id="area-list" class="table table-flush">
                <thead class="thead-light">
                <tr>
                  <th>Id</th>
                  <th>Nombre</th>
                  <th>Acción</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="item in items" :key="item.id">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>
                    <router-link class="action-link" :to="`/area/edit-area/${item.id}`">
                      <i class="fas fa-pencil-alt action color-accent" />
                    </router-link>
                    <router-link class="action-link" :to="`/area/delete-area/${item.id}`">
                      <i class="fas fa-trash action color-accent" />
                    </router-link>
                  </td>

                </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { DataTable } from "simple-datatables";
import Utils from "@/utils/Utils";


export default {
  name: "AreasList",
  components: {

  },
  data: () => ({
    isLoading: false,
    datatable: null,
    itemsUpload: [],
    showTable: true,
    items: [],
    textConfirmDelete: "¿Está seguro que desea eliminar el Area?",
    error: '',
    message: '',
    show_text: false,
    alert: false,
  }),
  watch: {
    '$store.state.areasList': function (areas) {
      this.items = areas;
      console.log("items: ", this.items);
      if (this.datatable) {
        this.datatable.destroy();
      }
      this.$nextTick(() => {
        this.datatable = new DataTable("#area-list", {
          searchable: true,
          fixedHeight: false,
          perPage: 15,
          perPageSelect: [15, 20, 25, 'Todos'],
          labels: {
            placeholder: "Buscar...", // Placeholder del campo de búsqueda
            perPage: "{select} registros por página", // Entradas por página
            noRows: "No hay registros", // Mensaje cuando no hay entradas
            noResults: "No se encontraron registros",// Mensaje cuando no hay entradas
            info: "Mostrando {start} a {end} de {rows} entradas", // Información de las entradas mostradas
          }
        });

        document.querySelector('.dataTable-dropdown').addEventListener('change', (event) => {
          if (event.target.value === "Todos") {
            console.log("mostrando todos:", this.items.length);
            this.datatable.options.perPage = this.items.length;
            this.datatable.update();
          }
        });
        let inputElement = document.querySelector(".dataTable-search input");
        let iconElement = document.createElement("i");
        iconElement.className = "fas fa-search";
        inputElement.parentNode.appendChild(iconElement);
        inputElement.placeholder = "Buscar...";
        inputElement.parentNode.style.position = "relative";
        iconElement.style.position = "absolute";
        iconElement.style.top = "50%";
        iconElement.style.right = "10px";
        iconElement.style.transform = "translateY(-50%)";

        let dropdownElement = document.querySelector(".dataTable-dropdown");
        let infoElement = document.querySelector(".dataTable-info");
        let paginationElement = document.querySelector(".dataTable-pagination");
        let bottomElement = document.querySelector(".dataTable-bottom");
        dropdownElement.parentNode.removeChild(dropdownElement);
        infoElement.parentNode.removeChild(infoElement);
        paginationElement.parentNode.removeChild(paginationElement);
        bottomElement.appendChild(infoElement);
        bottomElement.appendChild(dropdownElement);

        bottomElement.appendChild(paginationElement);
        bottomElement.style.display = "flex";
        bottomElement.style.justifyContent = "space-between";
      }).then(() => {
        this.isLoading = false;
      });
    },
  },

  methods: {
    deleteItemWrapper(itemId, event) {
      event.stopPropagation();
      this.deleteItem(itemId);
    },
    deleteItem(id) {
      alert(this.textConfirmDelete);
      console.log("eliminando usuario-id: ", id)
    },
    deleteUser(id) {
      console.log("eliminando usuario-id: ", id)

      // this.$store.dispatch("actionsDeleteUser", {
      //   axios: this.$axios,
      //   id: id,
      // });
    },
    dateHumanization(date) {
      return Utils.dateHumanization(date);
    },
  },
  async mounted() {
    this.isLoading = true;
    this.$store.dispatch('actionsGetAllAreas', {'axios': this.$axios});
    this.items = await this.$store.getters.getAllAreas;
    this.$store.state.ok = false;
    },
};
</script>
<style scoped>
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.loading-spinner {
  border: 16px solid #f3f3f3;
  border-radius: 50%;
  border-top: 16px solid #3498db;
  width: 120px;
  height: 120px;
  -webkit-animation: spin 2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite; /* Safari */
  animation: spin 2s cubic-bezier(0.68, -0.55, 0.27, 1.55) infinite;
}

/* Safari */
@-webkit-keyframes spin {
  0% { -webkit-transform: rotate(0deg); }
  100% { -webkit-transform: rotate(360deg); }
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}
.action-link {
  margin-right: 10px; /* Ajusta este valor según tus necesidades */
}
</style>
